import { ReflectUtils } from "@dooboostore/core";
const ValidMetadataKey = Symbol.for("simple-boot:valid-metadata");
const Valid = (target, propertyKey, parameterIndex) => {
  if (propertyKey && typeof target === "object") {
    target = target.constructor;
    const existingRequiredParameters = Reflect.getOwnMetadata(ValidMetadataKey, target, propertyKey) || [];
    existingRequiredParameters.push(parameterIndex);
    Reflect.defineMetadata(ValidMetadataKey, existingRequiredParameters, target, propertyKey);
  } else if (!propertyKey || typeof target === "function") {
    const existingRequiredParameters = Reflect.getOwnMetadata(ValidMetadataKey, target) || [];
    existingRequiredParameters.push(parameterIndex);
    Reflect.defineMetadata(ValidMetadataKey, existingRequiredParameters, target);
  }
};
const getValidIndex = (target, propertyKey) => {
  if (target !== null && void 0 !== target && typeof target === "object") {
    target = target.constructor;
  }
  if (propertyKey) {
    const parameters = Reflect.getOwnMetadata(ValidMetadataKey, target, propertyKey);
    return parameters ?? [];
  } else {
    return ReflectUtils.getMetadata(ValidMetadataKey, target) ?? [];
  }
};
const ValidationMetadataKey = Symbol.for("simple-boot:validation-metadata");
const Validation = (validator) => {
  return (target, propertyKey) => {
    const saves = ReflectUtils.getMetadata(ValidationMetadataKey, target.constructor) ?? [];
    saves.push({
      propertyKey,
      validator
    });
    ReflectUtils.defineMetadata(ValidationMetadataKey, saves, target.constructor);
    ReflectUtils.defineMetadata(ValidationMetadataKey, validator, target, propertyKey);
  };
};
const getValidator = (target, propertyKey) => {
  return ReflectUtils.getMetadata(ValidationMetadataKey, target, propertyKey);
};
const valid = Valid;
const validation = Validation;
const getValidators = (target) => {
  if (target !== null && void 0 !== target && typeof target === "object") {
    target = target.constructor;
  }
  return ReflectUtils.getMetadata(ValidationMetadataKey, target) ?? [];
};
const Regexp = (regexp) => {
  const content = (value, ...params) => {
    return regexp.test(value);
  };
  return content;
};
const NotNull = (value, ...params) => {
  return value !== null;
};
const NotEmpty = (value, ...params) => {
  return value !== null && value !== void 0 && (typeof value === "string" && value.length > 0 || Array.isArray(value) && value.length > 0);
};
const execValidationInValid = (obj) => {
  return execValidation(obj).filter((it) => !it.valid);
};
const execValidation = (obj) => {
  const validators = getValidators(obj);
  const reesults = [];
  validators.forEach((it) => {
    reesults.push({
      name: it.propertyKey,
      valid: it.validator(it.propertyKey, it),
      message: ""
    });
  });
  return reesults;
};
export {
  NotEmpty,
  NotNull,
  Regexp,
  Valid,
  Validation,
  execValidation,
  execValidationInValid,
  getValidIndex,
  getValidator,
  getValidators,
  valid,
  validation
};
//# sourceMappingURL=Validation.js.map
